import React from 'react';
import ReactDOM from 'react-dom';
import './lib/bootstrap.min.custom.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ModelProvider from "providers/ModelProvider";
import SettingsProvider from "providers/SettingsProvider";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <ModelProvider>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </ModelProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  console.log('serviceWorker');
  navigator.serviceWorker
    .register('./service-worker.js', { scope: './' })
    .then(function(registration) {
      console.log("Service Worker Registered");
    })
    .catch(function(err) {
      console.log("Service Worker Failed to Register", err);
    })

}
